import React, { useEffect, useState } from 'react';
import { ICONS } from '../ui';

// A chart that opens full screen when clicked (Esc or × closes it).
// render(height) draws the chart; height is null for the normal size.
export default function ChartFrame({ render, label }) {
  const [full, setFull] = useState(false);
  useEffect(() => {
    if (!full) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setFull(false); };
    window.addEventListener('keydown', onKey);
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = overflow; };
  }, [full]);
  return (
    <>
      <div className="chart-frame" onClick={() => setFull(true)}>
        <button type="button" className="chart-frame-expand" title="Full screen" aria-label={`Show ${label || 'chart'} full screen`}
          onClick={(e) => { e.stopPropagation(); setFull(true); }}>{ICONS.fullScreen}</button>
        {render(null)}
      </div>
      {full && (
        <div className="chart-fullscreen" role="dialog" aria-modal="true" aria-label={label || 'Chart'}>
          <button type="button" className="chart-fullscreen-close" title="Close" aria-label="Close" onClick={() => setFull(false)}>{ICONS.close}</button>
          {render(Math.max(300, window.innerHeight - 150))}
        </div>
      )}
    </>
  );
}
